import Owner from './Owner';
import Horizon from './Horizon';
import Tag from 'src/models/Tag';
import County from 'src/api/County';
import { LandSystem } from '../LandSystem';

export default class TractDetail {
    id: number;
    township: string;
    range: string;
    section: number;
    townshipId: number;
    tractNumber: number;
    tractName: string;
    grossAcres: number;
    legalDescription: string;
    countyId: number;
    horizons: Array<Horizon>;
    owners: Array<Owner>;
    county: County;
    examinationTypeId: number;
    note: string;
    totalInterest: number;
    executiveRights: number;
    nonExecutiveAdditionalOwnershipExists: boolean;
    landSystem: LandSystem;
    eastTexasAbstractIds: Array<number>;
    tags: Array<string>;
    addTags?: Array<Tag>;
    deleteTags?: Array<Tag>;
    isChild?: boolean;
    parcelID?: string;
    boundedByNorth?: string;
    boundedByEast?: string;
    boundedBySouth?: string;
    boundedByWest?: string;
    shortLegalDescription?: string;
    createdDate?: Date;
    modifiedDate?: Date;
    tractCreatedByName?: string;
    tractModifiedByName?: string;
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/TractDetail.ts